export default __webpack_public_path__ + "static/media/arearug.82c7ddc1.jpg";